const Server = require('helper/server');
const BaseComponent = require('base/base-component');
const Query = require('helper/query');
const AjaxTemplateSearch = require('common/ajax-template-search/extend');

const pdsTpl = Handlebars.templates['guigang/orgDetail/templates/pds-list'];
const staffTpl = Handlebars.templates['guigang/orgDetail/templates/staff-list'];
const performanceTpl = Handlebars.templates['guigang/orgDetail/templates/performance-list'];
const qualificationTpl = Handlebars.templates['guigang/orgDetail/templates/qualification-list'];
const pageTpl = Handlebars.templates['guigang/orgDetail/templates/pageTpl'];

class DetailPage extends BaseComponent {
  constructor () {
    super({
      events: {
        'error #basicInfo img': 'imgError',
        'click .Jsearch': 'searchList'
      }
    });
  }
  init () {
    this.query = new Query();
    this.$bread = this.$el.find('span.bread');
    this.req = {
      '#pds': false,
      '#staff': false,
      '#performance': false,
      '#qualification': false
    };
    if (this.query.get('supplierId')) {
      this.$el.find('.org-detail-content').html(pageTpl({
        _type: 'supplier'
      }));
      this.initSupplierInfo();
    } else {
      this.$el.find('.org-detail-content').html(pageTpl({
        _type: 'agency'
      }));
      this.initAgencyInfo();
    }
    this.$img = this.$el.find('#basicInfo img');
    this.$nopic = this.$el.find('#basicInfo .nopic');
  }
  initSupplierInfo () {
    const opts = {
      data: {
        supplierId: this.query.get('supplierId')
      }
    };
    // 供应商基本信息
    Server.getSupplierBaseInfo(opts)
      .then((data) => {
        this.$bread.text(`供应商 > ${data.fullName}`);
        fillText(this.$el.find('#basicInfo .detail,#info .detail').not('[data-name=\'mainscope\']'), data);
        if (data.logoPath) {
          this.$img.attr('src', data.logoPath).css('display', 'inline-block');
          this.$nopic.css('display', 'none');
        }
      });
    // 供应商企业信息
    Server.getCompanyInfo(opts)
      .then((data) => {
        data.bus && fillText(this.$el.find('.companyInfo .detail'), data.bus);
        data.tax && fillText(this.$el.find('.taxInfo .detail'), data.tax);
        data.social && fillText(this.$el.find('.socialecurityInfo .detail'), data.social);
        data.org && fillText(this.$el.find('.orgInfo .detail'), data.org);
        // 经营范围
        this.$el.find('#basicInfo span[data-name=\'mainscope\']').html(`${data.bus.mainscope ? data.bus.mainscope : ''} ${data.bus.sidescop ? data.bus.sidescop : ''}`);
      });
    // 供应商法人信息
    Server.getLegalInfo(opts)
      .then((data) => {
        fillText(this.$el.find('#legal .detail'), data);
      });
    // 供应商特定资质、信用信息
    Server.getCertificatesInfo(opts)
      .then((data) => {
        const $qtbody = $('#qualification tbody'); // 特点资质
        const $ctbody = $('#credit tbody'); // 信用信息
        let str1 = '';
        let str2 = '';
        for (let i in data) {
          let item = data[i];
          if (item.topType === 'SPECIFIC') {
            str1 += '<tr><td>' + format(item.certificateTypeName) + '</td><td>' +
              format(item.certificateLevelName) + '</td><td>' + format(item.certificateCode) + '</td><td>' + format(item.validtimeStart) +
              '</td><td>' + format(item.validtimeEnd) + '</td><td>' + format(item.latestchecktime) +
              '</td><td>' + format(item.certificateOrgname) + '</td></tr>';
          } else {
            str2 += '<tr><td>' + format(item.certificateTypeName) + '</td><td>' +
              format(item.certificateLevelName) + '</td><td>' + format(item.certificateCode) + '</td><td>' + format(item.validtimeStart) +
              '</td><td>' + format(item.validtimeEnd) + '</td><td>' + format(item.latestchecktime) +
              '</td><td>' + format(item.certificateOrgname) + '</td></tr>';
          }
        }
        $qtbody.append(str1);
        $ctbody.append(str2);
        if ($qtbody.find('td').length == 0) {
          $qtbody.append('<tr><td style="text-align: center; font-size: 36px; color: rgb(209, 226, 250); line-height: 100px;background:#FFFFFF" colspan="7">暂无数据</td></tr>');
        }
        if ($ctbody.find('td').length == 0) {
          $ctbody.append('<tr><td style="text-align: center; font-size: 36px; color: rgb(209, 226, 250); line-height: 100px;background:#FFFFFF" colspan="7">暂无数据</td></tr>');
        }
      });
  }

  initAgencyInfo () {
    const opts = {
      data: {
        orgId: this.query.get('orgId')
      }
    };
    Server.getAgencyBaseInfo(opts)
      .then((data) => {
        // 面包屑
        this.$bread.text(`代理机构 > ${data.fullName}`);

        // 业务范围
        data.businessScope = (data.aptitude.business.bizMainRange || '') + ' ' + (data.aptitude.business.bizConcurrentRange || '');
        // 官网地址
        if (data.webSite) {
          data.orgUrl = data.webSite.slice(0, 4) === 'http' ? data.webSite : `http://${data.webSite}`;
        } else {
          data.orgUrl = 'javascript:;';
        }
        // 机构logo图片
        if (!!data.fileVo && data.fileVo.downloadUrl) {
          data.logoImg = data.fileVo.downloadUrl;
          this.$img.css('display', 'inline-block');
          this.$nopic.css('display', 'none');
        }
        fillText(this.$el.find('#basicInfo .detail,#info .detail'), $.extend(data, data.aptitude.business));
      });
  }

  searchList (e) {
    const root = $(e.currentTarget).data('target');
    const opts = {
      root,
      appendElem: 'tbody',
      paginationSelector: '.js-pds-page',
      callback: () => {
        this.req[root] = true;
      }
    };
    switch (root) {
      case '#pds':
        opts.ajaxUrl = '/api/search/item/query';
        opts.template = pdsTpl;
        break;
      case '#staff':
        opts.ajaxUrl = '/api/core/remote/ageprofessionaList';
        opts.template = staffTpl;
        opts.extends = {
          qualifType: 'SPECIFIC'
        };
        break;
      case '#performance':
        opts.ajaxUrl = '/api/core/remote/ageperformanceList';
        opts.template = performanceTpl;
        opts.extends = {
          qualifType: 'SPECIFIC'
        };
        break;
      case '#qualification':
        opts.ajaxUrl = '/api/core/remote/agequalificationList';
        opts.template = qualificationTpl;
        opts.extends = {
          qualifType: 'SPECIFIC'
        };
        break;
    }
    if (this.req[root]) {
      return;
    }
    new AjaxTemplateSearch(opts);
  }
  imgError () {
    this.$img.css('display', 'none');
    this.$nopic.css('display', 'inline-block');
  }
}
module.exports = DetailPage;

function fillText (el, data) {
  let $el = null;
  if (el instanceof jQuery) {
    $el = el;
  } else {
    $el = $(el);
  }
  $el.each((i, item) => {
    const _n = $(item).attr('data-name');
    let _t = data[_n] || '';
    // 时间处理
    if (_t && (_n.indexOf('time') > -1 || _n == 'gmtCreate' || _n == 'inceptionDate')) {
      _t = moment(_t).format('YYYY-MM-DD');
    }
    if (item.tagName === 'IMG') {
      $(item).prop('src', _t);
    } else if (item.tagName === 'A') {
      $(item).prop('href', _t);
    } else {
      $(item).text(_t);
    }
  });
}

function format (data) {
  return data || '';
}
